/**
 * The session — **`@fiveox/shell`'s store, not ours**.
 *
 * ADR-0004 records why this file is eight lines rather than two hundred. The
 * shell already implements every obligation SSO_INTEGRATION §3.3/§3.4 names,
 * and it implements them *once for the whole estate*:
 *
 * - one place that ends a session (`clearSession`, reached from `refreshSession`)
 * - observable (`useSession` over `useSyncExternalStore`, so clearing it
 *   actually re-renders)
 * - a serialized refresh shared by concurrent callers
 * - only an **answer** from auth ends a session; a 5xx does not
 * - `signOutEverywhere` awaits `POST /logout` with `keepalive` before clearing
 *
 * The prototype's `lib/auth-store.ts` was a copy-adapt of the accounts app's
 * store with its own login screens behind it; ProDoc has no login screen
 * (platform ADR-0048, spec FR-1), so the store is the shell's and the screens
 * are accounts'. If something is missing here, the fix goes in the shell,
 * upstream.
 */

import { createSessionStore } from '@fiveox/shell'

import { AUTH_API } from './config'

/**
 * **Our own key** (SSO_INTEGRATION §3.2). Never read another app's storage:
 * different origins, and one app's session must never be revived from
 * another's.
 */
export const SESSION_KEY = 'fiveox.prodoc_session'

export const session = createSessionStore({
  key: SESSION_KEY,
  authApiUrl: AUTH_API,
})

export type { Session } from '@fiveox/shell'
